import  { useState, useEffect } from "react";
import { Table, Input, Modal, Spin, Space, DatePicker, Button } from "antd";
import { message } from "../../components/antdMessageBridge";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import CommonObj from "../../CommonObj";
import { Html5QrcodeScanType } from "html5-qrcode";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import "./recycleManifest.css";

const CodLifeCycle = ({ title, onDataChange }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(onDataChange || []);
  const { accessToken} = useAuthToken();
  const [errors, setErrors] = useState({});
  const { roleUserId } = useAuth();
  const [loadId, setLoadId] = useState("");
  const [activeScanner, setActiveScanner] = useState(null);
  const [decodedResults, setDecodedResults] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [codInput, setCodInput] = useState("");

  const [form, setForm] = useState({
    recycleBin: "",
    loadid: "",
    totalBookCount: "",
    weight: "",
    message: "",
  });
  const columns = [
    {
      title: "Load ID",
      dataIndex: "loadId",
      key: "loadId",
      width: "25%",
    },
    {
      title: "Total Recycle Bins",
      dataIndex: "binCount",
      key: "binCount",
      width: "25%",
    },
    {
      title: "Total Book Count",
      dataIndex: "bookCount",
      key: "bookCount",
      width: "25%",
    },

    {
      title: "Actions",
      key: "action",
      width: "25%",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          {}

          <div
            className="grid-comments-button-container"
            title="Enter COD Details"
          >
            <button
              className="comments-header-status-notification"
              onClick={() => showRejectModal(record)}
            >
              <svg
                width="23"
                height="23"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.5 12.5L10.5 14.5L15.5 9.5"
                  stroke="#1C274C"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.5"
                  d="M13.7658 2.15224C13.3983 2 12.9324 2 12.0005 2C11.0686 2 10.6027 2 10.2351 2.15224C9.74505 2.35523 9.35571 2.74458 9.15272 3.23463C9.06005 3.45834 9.02379 3.7185 9.0096 4.09799C8.98875 4.65568 8.70274 5.17189 8.21943 5.45093C7.73612 5.72996 7.14608 5.71954 6.65268 5.45876C6.31693 5.2813 6.07349 5.18262 5.83342 5.15102C5.30753 5.08178 4.77567 5.22429 4.35485 5.5472C4.03923 5.78938 3.80626 6.1929 3.34032 6.99993C2.87438 7.80697 2.64141 8.21048 2.58948 8.60491C2.52025 9.1308 2.66276 9.66266 2.98566 10.0835C3.13305 10.2756 3.34019 10.437 3.66167 10.639C4.13429 10.936 4.43838 11.4419 4.43835 12C4.43832 12.5581 4.13424 13.0639 3.66167 13.3608C3.34013 13.5629 3.13297 13.7244 2.98557 13.9165C2.66266 14.3373 2.52015 14.8691 2.58938 15.395C2.64131 15.7894 2.87428 16.193 3.34022 17C3.80616 17.807 4.03913 18.2106 4.35475 18.4527C4.77557 18.7756 5.30743 18.9181 5.83333 18.8489C6.07338 18.8173 6.31681 18.7186 6.65253 18.5412C7.14596 18.2804 7.73605 18.27 8.21939 18.549C8.70273 18.8281 8.98874 19.3443 9.0096 19.9021C9.0238 20.2815 9.06006 20.5417 9.15272 20.7654C9.35571 21.2554 9.74505 21.6448 10.2351 21.8478C10.6027 22 11.0686 22 12.0005 22C12.9324 22 13.3983 22 13.7658 21.8478C14.2559 21.6448 14.6452 21.2554 14.8482 20.7654C14.9409 20.5417 14.9772 20.2815 14.9914 19.902C15.0122 19.3443 15.2982 18.8281 15.7815 18.549C16.2648 18.2699 16.8549 18.2804 17.3484 18.5412C17.6841 18.7186 17.9275 18.8172 18.1675 18.8488C18.6934 18.9181 19.2253 18.7756 19.6461 18.4527C19.9617 18.2105 20.1947 17.807 20.6606 16.9999C21.1266 16.1929 21.3595 15.7894 21.4115 15.395C21.4807 14.8691 21.3382 14.3372 21.0153 13.9164C20.8679 13.7243 20.6607 13.5628 20.3392 13.3608C19.8666 13.0639 19.5626 12.558 19.5626 11.9999C19.5626 11.4418 19.8667 10.9361 20.3392 10.6392C20.6608 10.4371 20.868 10.2757 21.0154 10.0835C21.3383 9.66273 21.4808 9.13087 21.4116 8.60497C21.3596 8.21055 21.1267 7.80703 20.6607 7C20.1948 6.19297 19.9618 5.78945 19.6462 5.54727C19.2254 5.22436 18.6935 5.08185 18.1676 5.15109C17.9276 5.18269 17.6841 5.28136 17.3484 5.4588C16.855 5.71959 16.2649 5.73002 15.7816 5.45096C15.2982 5.17191 15.0122 4.65566 14.9914 4.09794C14.9772 3.71848 14.9409 3.45833 14.8482 3.23463C14.6452 2.74458 14.2559 2.35523 13.7658 2.15224Z"
                  stroke="#1C274C"
                  stroke-width="1.5"
                />
              </svg>
            </button>
          </div>
          <Button
            type="link"
            size="small"
            onClick={() => handleDelete(record.loadId)}
          >  
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.3751 4.5H2.625"
                stroke="#002449"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <path
                d="M14.125 6.375L13.78 11.5493C13.6473 13.5405 13.5809 14.5361 12.9322 15.1431C12.2834 15.75 11.2856 15.75 9.29001 15.75H8.70999C6.71439 15.75 5.71659 15.75 5.06783 15.1431C4.41907 14.5361 4.3527 13.5405 4.21996 11.5493L3.875 6.375"
                stroke="#002449"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <path
                opacity="0.5"
                d="M7.125 8.25L7.5 12"
                stroke="#002449"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <path
                opacity="0.5"
                d="M10.875 8.25L10.5 12"
                stroke="#002449"
                stroke-width="1.2"
                stroke-linecap="round"
              />
              <path
                opacity="0.5"
                d="M4.875 4.5C4.91691 4.5 4.93786 4.5 4.95686 4.49952C5.57444 4.48387 6.11927 4.09118 6.32941 3.51024C6.33588 3.49237 6.3425 3.47249 6.35576 3.43273L6.42857 3.21429C6.49073 3.02781 6.52181 2.93457 6.56304 2.8554C6.72751 2.53955 7.03181 2.32023 7.38346 2.26407C7.4716 2.25 7.56988 2.25 7.76645 2.25H10.2336C10.4301 2.25 10.5284 2.25 10.6165 2.26407C10.9682 2.32023 11.2725 2.53955 11.437 2.8554C11.4782 2.93457 11.5093 3.02781 11.5714 3.21429L11.6442 3.43273C11.6575 3.47244 11.6641 3.49238 11.6706 3.51024C11.8807 4.09118 12.4256 4.48387 13.0431 4.49952C13.0621 4.5 13.0831 4.5 13.125 4.5"
                stroke="#002449"
                stroke-width="1.2"
              />
            </svg>
          </Button>
        </Space>
      ),
    },
  ];


  useEffect(() => {
  }, [data]);

  const showRejectModal = (record) => {
    setCodInput("");
    setSelectedStartDate("");
    setLoadId(record.loadId);
    setIsModalVisible(true);
  };

  useEffect(() => {
    const uniqueResults = filterUniqueScans(decodedResults);
    if (uniqueResults?.length > 0 && activeScanner) {
      const latestResult = uniqueResults[uniqueResults?.length - 1];
      const scannedValue = latestResult?.decodedText;
      if (activeScanner === "Load ID") {
        setForm((prev) => {
          const currentRecycleBin = prev.recycleBin
            ? prev.recycleBin.trim()
            : "";
          const newRecycleBin = currentRecycleBin
            ? `${currentRecycleBin}, ${scannedValue}`
            : scannedValue;
          return { ...prev, recycleBin: newRecycleBin.trim() };
        });
      } else {
        setForm((prev) => {
          return { ...prev, [activeScanner.toLowerCase()]: scannedValue };
        });
      }

      setActiveScanner(null);
      setDecodedResults([]);
    }
  }, [decodedResults, activeScanner]);

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "odd-row" : "even-row";
  };

  function filterUniqueScans(results) {
    const filteredResults = [];
    if (results?.length === 0) {
      return filteredResults;
    }
    filteredResults.push(results[0]);
    for (let i = 1; i < results?.length; ++i) {
      if (results[i]?.decodedText !== results[i - 1]?.decodedText) {
        filteredResults.push(results[i]);
      }
    }
    return filteredResults;
  }

  const onNewScanResult = ( decodedResult) => {
    setDecodedResults((prev) => [...prev, decodedResult]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
    const trimmedRecycleBin = form.recycleBin.trim();

    if (!trimmedRecycleBin) {
      message.error("Please enter or scan a Load ID before proceeding.");
      return;
    }
    const recycleBinArray = trimmedRecycleBin
      .split(',')
      .map(item => item.trim())
      .filter(item => item.length > 0);

    if (recycleBinArray.length === 0) {
      message.error("Please enter valid Load ID(s).");
      return;
    }

    if (recycleBinArray.length > 1) {
      message.loading({
        content: `Processing ${recycleBinArray.length} Load ID(s)...`,
        key: "processingRecycleBins",
      });

      let successCount = 0;
      let failCount = 0;

      const results = await Promise.allSettled(
        recycleBinArray.map((recycleBin) => UserLogin(recycleBin.trim())),
      );

      results.forEach((result, index) => {
        if (result.status === "fulfilled" && result.value === true) {
          successCount++;
        } else {
          failCount++;
        }
      });

      message.destroy("processingRecycleBins");

      if (successCount > 0) {
        message.success(`Load ID(s) added successfully!`);
      }
      if (failCount > 0) {
        message.warning(`Load ID(s) failed to add.`);
      }
      setForm((prev) => ({ ...prev, recycleBin: "" }));
    } else {
      await UserLogin(recycleBinArray[0]);
      setForm((prev) => ({ ...prev, recycleBin: "" }));
    }
  };

  async function UserLogin(recycleBin) {
    const isBookInTable = data.some(
      (item) => item.loadId === recycleBin.trim(),
    );
    if (isBookInTable) {
      message.error(`Load ID already exists in the grid.`);
      return false;
    }
    setLoading(true);

    try {
      let payLoad = {
        pageNo: 1,
        pageSize: 10,
        search: "{}",
        orderByColumn: "LoadId",
        orderBy: "DESC",
        searchLoadID: recycleBin,
      };

      const response = await fetch(CommonObj.Endpoints.GetRecycleCODQueue, {
        method: "POST",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payLoad),
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const result = await response.json();
      console.log("shipmentResult", result?.error);
      if (result.error) {
        message.error(`Load ID not found or has not been shipped yet.`);
        return false;
      } else if (result[0]?.message.includes("Load Id Already Recycled")) {
        message.error(`Load ID has already been recycled.`);
        return false;
      } else if (result[0]?.message === "") {
        const bookData = result[0];
        setData((prevData) => [
          ...prevData,
          { ...bookData, key: bookData.recycleBin },
        ]);
        return true;
      }
    } catch (error) {
      console.error(error.message);
      message.error(
        `Failed to fetch data for recycleBin ${recycleBin}: ${error.message}`,
      );
      return false;
    } finally {
      setLoading(false);
    }
  }

  const handleSubmitFields = async (e) => {
    e.preventDefault();

    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
    if (!codInput || !selectedStartDate) {
      message.error(
        "COD Number and Date/Time are required to finalize the recycling process.",
      );
      return;
    }

    if (data.length === 0) {
      message.error("At least one Bin ID is required for shipment.");
      return;
    }

    const submissionData = {
      loadId: loadId,
      createdBy: roleUserId,
      cod: codInput,
      codDateTime: selectedStartDate
        ? selectedStartDate.format("YYYY-MM-DD HH:mm:ss")
        : null,
    };
    try {
      const baseUrl = CommonObj.Endpoints.RecycleCODSubmit;
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "X-CSRF-Token": encryptTimestamp(),
        },
        body: JSON.stringify(submissionData),
      });

      const result = await response.json();
      if (result.status) {
        message.success(
          "COD details captured and books are marked as Recycled",
        );
        setForm((prev) => ({ ...prev, recycleBin: "" }));
        setCodInput("");
        setSelectedStartDate("");
        setIsModalVisible(false);
        setData([]);
      } else {
        message.error(`${result.message || "Failed to submit the data."}`);
      }
    } catch (error) {
      message.error("Failed to submit the data.");
    } finally {
      setIsDisabled(false);
    }
  };
  const handleDelete = (key) => {
    console.log(data, "KEY");

    const newData = data.filter((item) => item.loadId !== key);
    setData(newData);
  };

  if (loading) {
    return (
      <Spin size="large" style={{ margin: "20px auto" }} />
    );
  }
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const disableFutureDates = (current) => {
    const today = new Date();
    return current && current > today;
  };

  const handleClear = () => {
    setCodInput("");
    setSelectedStartDate("");
  };
  return (
    <>
      <div>
        <Modal
          open={isModalVisible}
          width={400}
          className="recycle-cod-modal"
          height={400}
          centered
          closeIcon={
            <svg
              width="26"
              height="25"
              viewBox="0 0 26 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12.7139" cy="11.999" r="7.73924" stroke="#E93548" />
              <path
                d="M14.6489 10.0645L10.7793 13.9341M10.7793 10.0645L14.6489 13.9341"
                stroke="#E93548"
                stroke-linecap="round"
              />
            </svg>
          }
          title={
            <div className="title-content ">
              <div>
                <svg
                  width="233"
                  height="108"
                  viewBox="0 0 233 108"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    opacity="0.3"
                    cx="113.171"
                    cy="113.825"
                    rx="113.171"
                    ry="113.825"
                    transform="matrix(0.889167 0.457582 -0.46183 0.886968 65.4941 -160.898)"
                    fill="url(#paint0_linear_5337_32804)"
                    fill-opacity="0.2"
                  />
                  <ellipse
                    opacity="0.3"
                    cx="78.5699"
                    cy="78.9399"
                    rx="78.5699"
                    ry="78.9399"
                    transform="matrix(0.924999 0.379968 -0.387225 0.921985 71.2754 -110.457)"
                    fill="url(#paint1_linear_5337_32804)"
                    fill-opacity="0.2"
                  />
                  <g filter="url(#filter0_dd_5337_32804)">
                    <rect
                      x="93.666"
                      y="11"
                      width="39.4414"
                      height="39.4414"
                      rx="19.7207"
                      fill="url(#paint2_linear_5337_32804)"
                    />
                    <g clip-path="url(#clip0_5337_32804)">
                      <path
                        d="M125.666 23V37C125.666 39.209 123.875 41 121.666 41H119.651C119.651 41 119.651 41 119.65 40.998C120.486 38.486 121.666 34.106 121.663 29.364L121.666 27.518C121.93 27.651 122.206 27.758 122.489 27.837C123.078 28.002 123.666 27.572 123.666 26.961C123.666 26.483 123.38 26.03 122.925 25.885C122.599 25.781 122.298 25.609 122.037 25.385C121.738 25.129 121.369 25.001 121 25.001C120.631 25.001 120.262 25.129 119.963 25.385C119.512 25.771 118.947 26.001 118.333 26.001C117.719 26.001 117.154 25.771 116.703 25.385C116.404 25.129 116.035 25.001 115.666 25.001C115.297 25.001 114.928 25.129 114.629 25.385C114.178 25.771 113.613 26.001 112.999 26.001C112.385 26.001 111.82 25.771 111.369 25.385C111.07 25.129 110.701 25.001 110.332 25.001C109.963 25.001 109.594 25.129 109.295 25.385L109.281 25.397C108.644 25.936 107.665 25.465 107.665 24.63V23.001C107.666 20.794 109.46 19 111.666 19H121.666C123.875 19 125.666 20.791 125.666 23ZM119.665 29.458C119.665 33.602 118.687 37.488 117.867 40.025C117.292 41.804 115.644 43 113.767 43H104.988C103.867 43 102.78 42.418 102.151 41.48C101.57 40.616 101.456 39.585 101.837 38.655C102.66 36.643 104.193 32.898 104.243 29.485C104.247 29.196 104.376 28.924 104.596 28.737C105.08 28.335 105.816 28.007 106.409 27.998C107.03 27.988 107.653 28.194 108.159 28.614C108.767 29.118 109.639 29.118 110.246 28.614C111.236 27.793 112.674 27.793 113.664 28.614C114.271 29.118 115.143 29.118 115.751 28.614C116.262 28.19 116.892 27.985 117.518 27.999C118.106 28.012 118.775 28.283 119.255 28.681C119.501 28.861 119.651 29.142 119.664 29.447V29.459L119.665 29.458ZM112.144 32.121C111.774 31.92 111.314 31.972 110.998 32.256L109.498 33.602C109.087 33.97 109.053 34.603 109.422 35.014C109.66 35.28 110.007 35.388 110.338 35.331C110.168 36.558 109.955 37.899 109.693 38.684C109.518 39.208 109.801 39.775 110.325 39.949C110.43 39.984 110.537 40.001 110.641 40.001C111.06 40.001 111.45 39.736 111.59 39.317C111.989 38.119 112.594 33.536 112.654 33.157C112.72 32.739 112.516 32.323 112.144 32.121Z"
                        fill="white"
                      />
                    </g>
                  </g>
                  <defs>
                    <filter
                      id="filter0_dd_5337_32804"
                      x="57.4985"
                      y="-25.1675"
                      width="121.211"
                      height="121.211"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="4.7175" dy="4.7175" />
                      <feGaussianBlur stdDeviation="8.25562" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0.516129 0 0 0 0 1 0 0 0 0.1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_5337_32804"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="4.7175" dy="4.7175" />
                      <feGaussianBlur stdDeviation="20.4425" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.635294 0 0 0 0 0.823529 0 0 0 0 1 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_5337_32804"
                        result="effect2_dropShadow_5337_32804"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_5337_32804"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_5337_32804"
                      x1="72.8319"
                      y1="13.4217"
                      x2="103.372"
                      y2="200.6"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" stop-opacity="0.3" />
                      <stop offset="1" stop-color="#1383FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_5337_32804"
                      x1="50.5641"
                      y1="9.30818"
                      x2="71.7229"
                      y2="139.127"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" stop-opacity="0.3" />
                      <stop offset="1" stop-color="#1383FF" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_5337_32804"
                      x1="134.291"
                      y1="30.6118"
                      x2="93.5287"
                      y2="34.8462"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#033D9B" />
                      <stop offset="1" stop-color="#29ACD5" />
                    </linearGradient>
                    <clipPath id="clip0_5337_32804">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(101.666 19)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>Certificate Of Destruction</div>
            </div>
          }
          onOk={() => handleCancel()}
          onCancel={() => handleCancel()}
          footer={[
            <div className="book-page-buttons-container justify-space">
              <button className="modal-cancel-button" onClick={handleClear}>
                Clear
              </button>
              <button
                type="button"
                className="accept-button "
                disabled={isDisabled}
                onClick={handleSubmitFields}
              >
                Submit
              </button>
            </div>,
          ]}
        >
          <p class="recycle-cod">
            <div className="advance-filter-container">
              <div className="advance-filter-title-container"></div>
              <div className="advance-filter-body-container">
                <div className="advance-filter-input-container">
                  <div className="advance-filter-input-width">
                    <div className="field-group">
                      <input
                        placeholder=""
                        value={codInput}
                        className={`book-page-form-input-text ${codInput ? "has-text" : ""}`}
                        maxLength={100}
                        onChange={(e) => setCodInput(e.target.value)}
                        required
                        id="cod-input"
                      />
                      <label htmlFor="cod-input" className="label">
                        Enter COD#
                      </label>
                      {errors.codInput && (
                        <span className="error-msg">{errors.codInput}</span>
                      )}
                    </div>
                  </div>

                  <div className="advance-filter-input-width">
                    <div className="field-group">
                      <DatePicker
                        showTime={{ format: 'HH:mm' }}
                        format="YYYY-MM-DD HH:mm"
                        variant="underlined"
                        placement="topLeft"
                        placeholder=""
                        popupClassName="scaled-datepicker showHHMMOnly"
                        onChange={(date) => {
                          setSelectedStartDate(date);
                          setErrors({ ...errors, selectedStartDate: "" });
                        }}
                        value={selectedStartDate}
                        suffixIcon={
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_5398_419)">
                              <path
                                d="M6.66732 14.666C4.15316 14.666 2.89608 14.666 2.11503 13.885C1.33398 13.1039 1.33398 11.8468 1.33398 9.33268V7.99935C1.33398 5.48519 1.33398 4.22811 2.11503 3.44706C2.89608 2.66602 4.15316 2.66602 6.66732 2.66602H9.33398C11.8481 2.66602 13.1052 2.66602 13.8863 3.44706C14.6673 4.22811 14.6673 5.48519 14.6673 7.99935"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                              />
                              <path
                                opacity="0.5"
                                d="M4.66602 2.66602V1.66602"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                              />
                              <path
                                opacity="0.5"
                                d="M11.334 2.66602V1.66602"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                              />
                              <path
                                opacity="0.5"
                                d="M1.33398 6H14.6673"
                                stroke="#002449"
                                stroke-width="1.2"
                                stroke-linecap="round"
                              />
                              <g clip-path="url(#clip1_5398_419)">
                                <circle
                                  cx="11.3333"
                                  cy="11.9993"
                                  r="3.33333"
                                  stroke="#002449"
                                  stroke-width="1.2"
                                />
                                <path
                                  d="M11.334 10.666V11.9993L12.1673 12.8327"
                                  stroke="#002449"
                                  stroke-width="1.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </g>
                              <path
                                d="M8.66732 8.66667C8.66732 9.03486 8.36884 9.33333 8.00065 9.33333C7.63246 9.33333 7.33398 9.03486 7.33398 8.66667C7.33398 8.29848 7.63246 8 8.00065 8C8.36884 8 8.66732 8.29848 8.66732 8.66667Z"
                                fill="#002449"
                              />
                              <path
                                d="M5.33333 11.3333C5.33333 11.7015 5.03486 12 4.66667 12C4.29848 12 4 11.7015 4 11.3333C4 10.9651 4.29848 10.6667 4.66667 10.6667C5.03486 10.6667 5.33333 10.9651 5.33333 11.3333Z"
                                fill="#002449"
                              />
                              <path
                                d="M5.33333 8.66667C5.33333 9.03486 5.03486 9.33333 4.66667 9.33333C4.29848 9.33333 4 9.03486 4 8.66667C4 8.29848 4.29848 8 4.66667 8C5.03486 8 5.33333 8.29848 5.33333 8.66667Z"
                                fill="#002449"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_5398_419">
                                <rect
                                  width="16"
                                  height="16"
                                  rx="5"
                                  fill="white"
                                />
                              </clipPath>
                              <clipPath id="clip1_5398_419">
                                <rect
                                  width="8"
                                  height="8"
                                  fill="white"
                                  transform="translate(7.33398 8)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        }
                        disabledDate={disableFutureDates}
                        className={`book-page-form-input-text ${selectedStartDate ? "has-text" : ""}`}
                        allowClear={false}
                        id="startdate-report-1"
                      />
                      <label
                        htmlFor="startdate-report-1"
                        className="startfloatLabel"
                      >
                        Enter Date & Time
                      </label>
                      {errors.startdate && (
                        <span className="error-msg">
                          {errors.selectedStartDate}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p>
          <p className="modal-border"></p>
        </Modal>
      </div>
      <Modal
        title={`Scan ${activeScanner ? activeScanner : ""}`}
        open={!!activeScanner}
        onCancel={() => setActiveScanner(null)}
        footer={null}
        destroyOnClose
        width={1000}
        className="scan-model-container"
      >
        <div className="scan-modal">
          <Html5QrcodePlugin
            fps={30}
            qrbox={{ width: 1000, height: 400 }}
            aspectRatio={2.8}
            disableFlip={false}
            qrCodeSuccessCallback={onNewScanResult}
            supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
          />
        </div>
      </Modal>

      <div className="book-page-form">
        <div className="book-page-camera-button-container multiple scanner-unrestricted-field">
          <Input
            placeholder=""
            value={form.recycleBin}
            className={`${form.recycleBin ? "has-id" : ""}`}
            onChange={(e) => setForm({ ...form, recycleBin: e.target.value })}
            onPressEnter={handleSubmit}
            id="cutting-batch-bid-input-id"
            disabled={isDisabled}
          />
          {form.recycleBin.length === 0 && (
            <label htmlFor="cutting-batch-bid-input-id">
              Enter Load ID / Scan “<strong>Load ID</strong>”
              <span className="form-required">*</span>
            </label>
          )}
          <button
            type="button"
            className="book-page-camera-button"
            data-track="cod-open-loadid-scanner"
            onClick={() => {
              setDecodedResults([]);
              setActiveScanner("Load ID");
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="13"
                r="3"
                stroke="#1C274C"
                strokeWidth="1.5"
              />
              <path
                opacity="0.5"
                d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                stroke="#1C274C"
                strokeWidth="1.5"
              />
              <path
                d="M18 10H17.5"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                opacity="0.5"
                d="M14.5 3.5H9.5"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                fill="url(#paint0_linear_273_6917)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                fill="url(#paint1_linear_273_6917)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_273_6917"
                  x1="22.601"
                  y1="11.9503"
                  x2="1.98296"
                  y2="14.3301"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_273_6917"
                  x1="22.601"
                  y1="11.9503"
                  x2="1.98296"
                  y2="14.3301"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            type="button"
            className="book-page-camera-button-input-2"
            onClick={handleSubmit}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                fill="url(#paint0_linear_1900_8687)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1900_8687"
                  x1="20.6"
                  y1="9.94475"
                  x2="-0.0696504"
                  y2="12.0919"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#033D9B" />
                  <stop offset="1" stopColor="#29ACD5" />
                </linearGradient>
              </defs>
            </svg>
          </button>
        </div>
      </div>
      <div className="table-container">
        <div className="rounded-table-wrapper">
          <Table
            columns={columns}
            dataSource={data}
            className="common-grid cutting-batch-processing comments-grid"
            pagination={false}
            rowKey={(record) => record.recycleBin}
            scroll={{ x: "max-content", y: "calc(100vh - 455px)" }}
            rowClassName={getRowClassName}
          />
        </div>
      </div>
      <div className="book-page-footer-container">
        <div className="book-page-action-container">
          <div className="book-page-buttons-container justify-space-rack"></div>
        </div>
      </div>
    </>
  );
};

export default CodLifeCycle;
